import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import {
Paper,
Table,
TableBody,
TableCell,
TableContainer,
TableHead,
TableRow,
Grid,
Typography,
Stack,
FormControlLabel,
Radio,
RadioGroup,
FormControl,
Chip,
IconButton,
TablePagination,
Select,
MenuItem,
InputLabel,
Button,
Accordion,
AccordionSummary,
AccordionDetails,
Collapse

} from '@mui/material';
import { Container } from 'reactstrap';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import DownloadIcon from '@mui/icons-material/Download';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import XLSXS from 'xlsx-js-style';
import moment from 'moment';
import numeral from 'numeral';
import { ReactComponent as MastersIcon } from '../media/filter.svg';
import axios from '../axiosConfig';



// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '800',
  // textAlign: 'center',
  backgroundColor: '#219C90',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const ProcessEmpMap = () => {

 const tokent =
 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
 const [searchTerm, setSearchTerm] = useState('');
 const [userTypeFilter, setUserTypeFilter] = useState('Employee');
 const [usersData, setusersData] = useState([]);
 const [openLoader, setOpenLoader] = useState(false);
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);
const [selectedProcess, setSelectedProcess] = useState({ DepartmentId: 0 , DepartmentDescription: 'All' });
const [processData, setProcessData] = useState([]);
const [expanded, setExpanded] = React.useState(true);
const [totalSalaryAmt, settotalSalaryAmt] = useState('')
const [totalDaySalaryAmt, settotalDaySalaryAmt] = useState('')


   useEffect(() => {
     getAllDepartment();
   }, []);

   const getData = async (isUser) => {
     setOpenLoader(true);
     try {
       const res = await axios.instance.post('/GetEmpData',
        { user : isUser ,
          DepartmentId : selectedProcess.DepartmentId
        },
         {
         headers: { Authorization: tokent, 'Content-Type': 'application/json' },
       });
       setusersData(res.data);
       setOpenLoader(false);
       // console.log('users', res.data);
     } catch (error) {
       console.error('Error fetching courses:', error);
     }
   };

    // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, usersData.length - page * rowsPerPage);
  const totalRows = usersData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1)); // Clamp to the range [0, totalPages - 1]


    useEffect(() => {
      setPage(0);
    }, [searchTerm]);

    const handleProcessChange = async (event) => {
    const selectedProcessId = event.target.value;
    setusersData([]);

    if (Number(selectedProcessId) === 0) {
      setSelectedProcess({ DepartmentId: 0, DepartmentDescription: 'All' });
      return;
    }
    const selectedProcessObj = processData.find((process) => process.DepartmentId.toString() === selectedProcessId);

    setSelectedProcess(selectedProcessObj);
  };

  const getAllDepartment = async () => {
      try {
        const userId = sessionStorage.getItem('UserID');
        const res = await axios.instance.get(`/GetAllDepartmentMstData`,
         {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setProcessData(res.data);
        return res.data;
      } catch (error) {
        console.error('Error fetching process data:', error);
        return [];
      }
    };

      const applyFilters = async () => {
       if(userTypeFilter === 'Employee' )
        { 
          getData('N') 
         }
         else{ 
          getData('Y')
        }
          setPage(0);
          // setExpanded(false);
      };

    useEffect(() => {
    const totalSalaryAmt = usersData.reduce((acc, obj) => {
    return acc + Number(obj.Salary || 0);
  }, 0);
  settotalSalaryAmt(totalSalaryAmt);
}, [usersData]);

    useEffect(() => {
    const totalDaySalaryAmt = usersData.reduce((acc, obj) => {
    return acc + Number(obj.Salary / 26 || 0);
  }, 0);
  settotalDaySalaryAmt(totalDaySalaryAmt);
}, [usersData]);



      const resetFilters = () =>{
        setusersData([]);
        setUserTypeFilter('Employee');
        setSelectedProcess({ DepartmentId: 0, DepartmentDescription: 'All' });
        setPage(0);
      }

        const handleExpansion = () => {
          setExpanded((prevExpanded) => !prevExpanded);
  };

   const exportToExcel = () => {
       if (usersData.length === 0) return;
   
       const wb = XLSXS.utils.book_new();
       const isUser = userTypeFilter === 'User';
       const title = isUser ? 'Process User Map' : 'Process Employee Map';
       const Date = moment().format('DD-MM-YYYY');
       const DepartmentName = selectedProcess.DepartmentId === 0 ? 'AllDepartment' : selectedProcess.DepartmentDescription;
      
       const headers = [
         'S.No', 'Employee Code', 'Name', 'Gender', 
         'Department', 'Designation', 'Grade','Line' , 'Salary', 'Day Salary',
        //  'Min Salary'
        'Status','Email', 'Phone'
       ];
   
       const data = usersData.map((user, index) => {
         const row = {
           'S.No': index + 1,
           'Employee Code': user.UserCode || '',
           'Name': user.Users || '',
           'Gender': user.Gender === 'M' ? 'Male' : (user.Gender === 'F' ? 'Female' : ''),
           'Department': user.DepartmentDescription || '',
           'Designation': user.DesignationDescription || '',
           'Grade': user.GradeName || '',
           'Line': user.LineName || '',
           'Salary': user.Salary ? Number(user.Salary) : 0,
           'Day Salary': user.Salary ? Number(user.Salary / 26 ).toFixed(2) : 0,
           // 'Min Salary': user.Salary ? Number(user.Salary / 26 / 8 ).toFixed(2) : 0
           'Status': user.ActiveStatus === 'Y' ? 'Active' : 'Inactive',
           'Email': user.Email || '',
           'Phone': user.PhoneNumber || '',
         };
         return row;
       });



       const totalSalary = usersData.reduce((sum, u) => sum + Number(u.Salary || 0), 0);
const totalDaySalary = usersData.reduce((sum, u) => sum + Number((u.Salary || 0) / 26), 0);

data.push({
  'S.No': '',
  'Employee Code': '',
  'Name': '',
  'Gender': '',
  'Department': '',
  'Designation': '',
  'Grade': '',
  'Line': '',
  'Salary': totalSalary,
  'Day Salary': totalDaySalary.toFixed(2),
  'Status': '',
  'Email': '',
  'Phone': '',
});

       const startRow = 6;
       const ws = XLSXS.utils.json_to_sheet(data, { origin: `A${startRow}`, header: headers });
   
       // Title row
       ws.A1 = {
         v: title,
         t: 's',
         s: {
           font: { bold: true, sz: 16, color: { rgb: 'FFFFFF' } },
           alignment: { horizontal: 'center', vertical: 'center' },
           fill: { fgColor: { rgb: 'FF219C90' } },
         },
       };
   
       // Generated date
       ws.A2 = {
         v: `Generated on: ${moment().format('DD-MM-YYYY HH:mm:ss')}`,
         t: 's',
         s: {
           font: { sz: 10, color: { rgb: '666666' } },
           alignment: { horizontal: 'right' },
         },
       };

           ws.A3 = {
         v: `Date: ${Date}`,
         t: 's',
         s: {
           font: { sz: 11, color: { rgb: '000000' } },
           alignment: { horizontal: 'left' },
         },
       };

           ws.A4 = {
         v: `Department Name: ${DepartmentName}`,
         t: 's',
         s: {
           font: { sz: 11, color: { rgb: '000000' } },
           alignment: { horizontal: 'left' },
         },
       };

       const lastColIndex = headers.length - 1;
       const lastColLetter = String.fromCharCode(65 + Math.min(lastColIndex, 25));
   
       // Merge title row
       ws['!merges'] = [
         { s: { r: 0, c: 0 }, e: { r: 0, c: lastColIndex } },
         { s: { r: 1, c: 0 }, e: { r: 1, c: lastColIndex } },
       ];
   
       // Style header row
       const headerRowIndex = startRow - 1;
       headers.forEach((header, colIdx) => {
         const cellRef = XLSXS.utils.encode_cell({ r: headerRowIndex, c: colIdx });
         if (ws[cellRef]) {
           ws[cellRef].s = {
             font: { bold: true, sz: 10, color: { rgb: 'FFFFFF' } },
             fill: { fgColor: { rgb: 'FF134E5E' } },
             alignment: { horizontal: 'center', vertical: 'center' },
             border: {
               top: { style: 'thin', color: { rgb: 'E0E0E0' } },
               bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
               left: { style: 'thin', color: { rgb: 'E0E0E0' } },
               right: { style: 'thin', color: { rgb: 'E0E0E0' } },
             },
           };
         }
       });
   
       // Style data rows
       data.forEach((row, rowIdx) => {
         const excelRow = startRow + rowIdx;
         headers.forEach((header, colIdx) => {
           const cellRef = XLSXS.utils.encode_cell({ r: excelRow, c: colIdx });
           if (ws[cellRef]) {
             const isEvenRow = rowIdx % 2 === 0;
             const statusVal = ws[cellRef].v;
             let fontColor = '000000';
             let bgColor = isEvenRow ? 'FFFFFF' : 'F9F9F9';
   
             if (header === 'Status') {
               fontColor = statusVal === 'Active' ? '008000' : 'FF0000';
               bgColor = statusVal === 'Active' ? 'E8F5E8' : 'FFE8E8';
             }
   
             ws[cellRef].s = {
               font: {
                 sz: 10,
                 color: { rgb: fontColor },
                 ...(header === 'Salary' ? { name: 'Courier New' } : {}),
                 ...(header === 'Status' || header === 'Salary' ? { bold: true } : {}),
               },
               fill: { fgColor: { rgb: bgColor } },
               alignment: {
                 horizontal: header === 'S.No' || header === 'Grade' || header === 'Status' ? 'center'
                   : header === 'Salary' || header === 'Day Salary'  ? 'right' : 'left',
               },
               border: {
                 top: { style: 'thin', color: { rgb: 'E0E0E0' } },
                 bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
                 left: { style: 'thin', color: { rgb: 'E0E0E0' } },
                 right: { style: 'thin', color: { rgb: 'E0E0E0' } },
               },
             };
             if (header === 'Salary' || header === 'Day Salary') {
  ws[cellRef].t = 'n';
  ws[cellRef].z = '#,##,##0.00';
}
           }
         });
       });

       // ===== TOTAL ROW MERGE + STYLE =====

const totalRowIndex = startRow + data.length - 1;

// Ensure merges array exists
if (!ws['!merges']) ws['!merges'] = [];

// Merge columns A → H (colspan 8)
ws['!merges'].push({
  s: { r: totalRowIndex, c: 0 },
  e: { r: totalRowIndex, c: 7 },
});

// TOTAL label cell (A column)
const totalLabelCell = XLSXS.utils.encode_cell({ r: totalRowIndex, c: 0 });

ws[totalLabelCell] = {
  v: 'TOTAL',
  t: 's',
  s: {
    font: { bold: true, color: { rgb: 'FFFFFF' } },
    fill: { fgColor: { rgb: 'FF219C90' } },
    alignment: { horizontal: 'right', vertical: 'center' },
    border: {
      top: { style: 'thin', color: { rgb: 'E0E0E0' } },
      bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
      left: { style: 'thin', color: { rgb: 'E0E0E0' } },
      right: { style: 'thin', color: { rgb: 'E0E0E0' } },
    },
  },
};

// Salary (col 8 → I)
const totalSalaryCell = XLSXS.utils.encode_cell({ r: totalRowIndex, c: 8 });

// Day Salary (col 9 → J)
const totalDaySalaryCell = XLSXS.utils.encode_cell({ r: totalRowIndex, c: 9 });

// Apply style to Salary & Day Salary cells
[totalSalaryCell, totalDaySalaryCell].forEach((cellRef) => {
  if (ws[cellRef]) {
    ws[cellRef].s = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: 'FF219C90' } },
      alignment: { horizontal: 'right', vertical: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: 'E0E0E0' } },
        bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
        left: { style: 'thin', color: { rgb: 'E0E0E0' } },
        right: { style: 'thin', color: { rgb: 'E0E0E0' } },
      },
    };
  }
});
// Fill remaining cells (Status, Email, Phone)
for (let col = 10; col < headers.length; col+=1) {
  const cellRef = XLSXS.utils.encode_cell({ r: totalRowIndex, c: col });

  ws[cellRef] = {
    v: '',
    t: 's',
    s: {
      fill: { fgColor: { rgb: 'FF219C90' } },
      border: {
        top: { style: 'thin', color: { rgb: 'E0E0E0' } },
        bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
        left: { style: 'thin', color: { rgb: 'E0E0E0' } },
        right: { style: 'thin', color: { rgb: 'E0E0E0' } },
      },
    },
  };
}
   
       // Column widths
       ws['!cols'] = [
         { wch: 6 },   // S.No
         { wch: 14 },  // Employee Code
         { wch: 22 },  // Name
         { wch: 8 },   // Gender
         { wch: 16 },  // Department
         { wch: 18 },  // Designation
         { wch: 8 },   // Grade
         { wch: 12 },  // Line
         { wch: 12 },  // Salary
         { wch: 12 },  // Day Salary
         { wch: 12 },  // Status
         { wch: 22 },  // Email
         { wch: 12 },  // Phone
       ];
   
       ws['!ref'] = `A1:${lastColLetter}${startRow + data.length}`;
   
       XLSXS.utils.book_append_sheet(wb, ws, title);
       XLSXS.writeFile(wb, `${title.replace(/ /g, '_')}_${moment().format('DD-MM-YYYY')}.xlsx`);
     };


  return (
    <Container  maxWidth={'xl'} elevation={3} >
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2} mb={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #134e5e, #71b280)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Process Employee Map Report
            </Typography>
          </Typography>
        </Grid>
       <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 3, my: 2 }}>
  <Accordion
    expanded={expanded}
    onChange={handleExpansion}
    disableGutters
    sx={{ backgroundColor: 'inherit' }}
  >

    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#36BA98' }} />}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <IconButton size="small">
          <MastersIcon style={{ width: 20, height: 20 }} />
        </IconButton>
        <Typography variant="subtitle1" sx={{ color: '#36BA98', fontWeight: 600 }}>
          Filters
        </Typography>
      </Stack>
    </AccordionSummary>


    <AccordionDetails sx={{ py: 1, px: 2 }}>
      <Grid container alignItems="center" spacing={1}>

     
        <Grid item xs="auto" sx={{ ml: 10 }}>
          <FormControl component="fieldset">
            <RadioGroup
              row
              value={userTypeFilter}
              onChange={(e) => setUserTypeFilter(e.target.value)}
            >
              <FormControlLabel
                value="Employee"
                control={<Radio size="small" />}
                label="Employee"
                sx={{ mr: 1 }}
                onClick={() => setusersData([])}
              />
              <FormControlLabel
                value="User"
                control={<Radio size="small" />}
                label="User"
                onClick={() => setusersData([])}
              />
            </RadioGroup>
          </FormControl>
        </Grid>

  
        <Grid item xs="auto">
          <FormControl size="small" sx={{ minWidth: 250 }}>
            <InputLabel>Select Department</InputLabel>
            <Select
              value={selectedProcess.DepartmentId}
              label="Select Department"
              onChange={handleProcessChange}
            >
              <MenuItem value={0}>All</MenuItem>
              {processData.map((process) => (
                <MenuItem
                  key={process.DepartmentId}
                  value={process.DepartmentId.toString()}
                >
                  {process.DepartmentDescription}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

  
        <Grid item xs />
        <Grid item xs="auto">
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              size="medium"
              color="secondary"
              onClick={applyFilters}
              startIcon={<FilterAltIcon />}
            >
              Apply Filter
            </Button>

            <Button
              variant="contained"
              size="medium"
              color="warning"
              onClick={resetFilters}
              startIcon={<LockResetIcon />}
            >
              Reset
            </Button>

            <Button
              variant="contained"
              size="medium"
              color="success"
              onClick={exportToExcel}
              startIcon={<DownloadIcon />}
              disabled={usersData.length === 0}
              sx={{ boxShadow: 0 }}
            >
              Export Excel
            </Button>
          </Stack>
        </Grid>

      </Grid>
    </AccordionDetails>
  </Accordion>
</Stack>

        <Collapse in={usersData.length > 0}>
        <>
        <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                <Table size="small">
                  <TableHead>
                  <TableRow>
                                 <StyledTableCell align="center">S.No</StyledTableCell>
                 
                                 {/* Personal Information */}
                                 <StyledTableCell align="left">Code</StyledTableCell>
                                 <StyledTableCell align="left">Name</StyledTableCell>
                                 <StyledTableCell align="left">Gender</StyledTableCell>
                                
                                 {/* Job Details */}
                                 <StyledTableCell align="left">Department</StyledTableCell>
                                 <StyledTableCell align="left">Designation</StyledTableCell>
                                 <StyledTableCell align="left">Grade</StyledTableCell>
                                 <StyledTableCell align="left">Line</StyledTableCell>
                                 <StyledTableCell align="right">Salary</StyledTableCell>

                                 {/* Status & Actions */}
                                 <StyledTableCell align="center">Day Salary</StyledTableCell>
                                 <StyledTableCell align="center">Status</StyledTableCell>

                                 {/* <StyledTableCell align="center">Min Salary</StyledTableCell> */}

                                 <StyledTableCell align="center">Email</StyledTableCell>
                                 <StyledTableCell align="center">Phone</StyledTableCell>
                                 
                               </TableRow>
                               </TableHead>
                   <TableBody>
        {(rowsPerPage > 0
                ? usersData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : usersData
              ).map((user, index) => (
      <TableRow key={user.UserAccessID} hover>
        <TableCell align="center">{user.SNo}</TableCell>
        <TableCell align="left">{user.UserCode}</TableCell>
        <TableCell align="left">{user.Users}</TableCell>
        <TableCell align="left">{user.Gender === 'M' ? 'Male' : 'Female' }</TableCell>
        <TableCell align="left">{user.DepartmentDescription}</TableCell>
        <TableCell align="left">{user.DesignationDescription}</TableCell>
        <TableCell align="left">{user.GradeName}</TableCell>
        <TableCell align="left">{user.LineName}</TableCell>
        <TableCell align="right">{Number(user.Salary ?? 0).toLocaleString('en-IN')}</TableCell>
      <TableCell align="right">
  {user.Salary
    ? Number(user.Salary / 26).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    : '0.00'}
</TableCell>


       {/* <TableCell align="right">
          {user.Salary
          ? (user.Salary / 26 / 480 ).toFixed(2) : 0}</TableCell> */}

           <TableCell align="center"  sx={{ padding: '0' }}>
                    {user.ActiveStatus === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>

        <TableCell align="left">{user.Email}</TableCell>
        <TableCell align="left">{user.PhoneNumber}</TableCell>

      </TableRow>
    ))}

    <TableRow>
                        <TableCell
                          style={{ backgroundColor: '#EEEDEB', color: '#219C90', fontWeight: 'bolder' }}
                          colSpan={8}
                          align="right"
                        >
                          {'Total'}
                        </TableCell>
                        <TableCell
                          style={{ backgroundColor: '#EEEDEB', color: '#219C90', fontWeight: 'bolder' }}
                          // colSpan={1}
                          align="right"
                        >
                          {numeral(totalSalaryAmt).format('0,0.00')}
                        </TableCell>
                         <TableCell
                          style={{ backgroundColor: '#EEEDEB', color: '#219C90', fontWeight: 'bolder' }}
                          // colSpan={1}
                          align="right"
                        >
                          {numeral(totalDaySalaryAmt).format('0,0.00')}
                        </TableCell>
                         <TableCell colSpan={3} sx={{ backgroundColor: '#EEEDEB' }} />
                      </TableRow>
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )}
                </TableBody> 
                  </Table>
                </TableContainer>
                <TablePagination
                          rowsPerPageOptions={[5, 10, 25]}
                          component="div"
                          count={totalRows}
                          rowsPerPage={rowsPerPage}
                          page={currentPage} // Use the calculated currentPage value
                          onPageChange={(event, newPage) => setPage(newPage)}
                          onRowsPerPageChange={(event) => {
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0); // Reset the page when rowsPerPage changes
                          }}
                          mt={2}
                        />
        </>
        </Collapse>
    </Container>

  )
}

export default ProcessEmpMap
